export enum NodeEnvironment {
  DEV = 'dev',
  UAT = 'uat',
  PROD = 'production',
}

export enum AnalyticsEvent {
  ESTATE_CREATED = 'Estate Created',
  PAGE_VIEW = 'Page View',
  TASK_ASSIGNED = 'Task Assigned',
  LOGIN = 'Login',
  LOGOUT = 'Logout',
}
